import { useEffect } from 'react';
import { useThemeStore } from '../stores';

/**
 * Hook that applies the current theme to the document element
 * Call this at the root of your app to enable theming
 */
export const useTheme = () => {
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    // Remove both theme attributes first
    document.documentElement.removeAttribute('data-theme');
    
    // Apply the current theme
    if (theme === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
    }
    // For dark theme, we don't need to set attribute as it's the default
  }, [theme]);

  return theme;
};

